var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DataTree } from '@juvare/common-web-ui/DataTree';
import { showCustomDialog, showErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { LayoutRows2 } from '@juvare/common-web-ui/LayoutRows2';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, Button, IconButton, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { useDocumentLibraryStorage, useDocumentLibraryTranslations } from '../../../hooks';
export const DirectoryTree = (props) => {
    const { t } = useDocumentLibraryTranslations();
    const storage = useDocumentLibraryStorage();
    const service = React.useMemo(() => {
        return {
            id: (item) => { var _a, _b; return (_b = (_a = item.row) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 'root'; },
            expand: (item) => { var _a; return !((_a = item.row) === null || _a === void 0 ? void 0 : _a.id); },
            children: (item) => item.children,
            fullyDisable: (item) => (item.row ? !item.row.permissions.includes('modify') : false),
            list: () => __awaiter(void 0, void 0, void 0, function* () {
                const listResponse = yield storage.listFiles({
                    flatList: true,
                    filter: [{ column: 'directory', op: '=', value: true }],
                    orderBy: [{ column: 'name' }],
                });
                const tree = buildDirectoryTree(listResponse.rows);
                if (props.showRootDirectory) {
                    return [
                        {
                            children: tree,
                        },
                    ];
                }
                else {
                    return tree;
                }
            }),
        };
        // TODO Andrius Sukys - change from useMemoOne to React.useMemo resulted in this eslint warning
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.showRootDirectory]);
    return (React.createElement(DataTree, { service: service, renderItem: (directory) => { var _a, _b; return (_b = (_a = directory.row) === null || _a === void 0 ? void 0 : _a.columns.name) !== null && _b !== void 0 ? _b : t('documentPanel.title'); }, selectedItemId: props.selectedDirectoryId, onSelectItem: (directory) => {
            var _a;
            if ((!directory.row && props.showRootDirectory) || ((_a = directory.row) === null || _a === void 0 ? void 0 : _a.permissions.includes('write'))) {
                props.onSelectDirectory(directory.row);
            }
            else {
                showErrorDialog({
                    title: 'You do not have permissions to this directory',
                    onClose: () => undefined,
                });
            }
        } }));
};
export function showDirectoryTreeDialog(params) {
    showCustomDialog({
        fullScreen: true,
        content: (close) => React.createElement(DirectoryTreeDialogContent, Object.assign({}, params, { onClose: close })),
    });
}
const DirectoryTreeDialogContent = (props) => {
    const [selectedDirectory, setSelectedDirectory] = React.useState();
    const { t } = useDocumentLibraryTranslations();
    return (React.createElement(LayoutRows2, { row1: React.createElement(AppBar, { sx: { position: 'relative' } },
            React.createElement(Toolbar, null,
                React.createElement(IconButton, { edge: 'start', color: 'inherit', onClick: () => props.onClose(), size: 'large', "aria-label": t('common.close') },
                    React.createElement(CloseIcon, null)),
                React.createElement(Typography, { variant: 'h6', sx: { marginLeft: 2, flex: 1 } }, props.title),
                React.createElement(Button, { autoFocus: true, color: 'inherit', onClick: () => props.onClose(() => props.onChange(selectedDirectory)), "data-test": 'select-directory' }, "Select"))), row2: React.createElement(Box, { sx: { height: '100%' } },
            React.createElement(DirectoryTree, { showRootDirectory: props.showRootDirectory, selectedDirectoryId: selectedDirectory === null || selectedDirectory === void 0 ? void 0 : selectedDirectory.id, onSelectDirectory: setSelectedDirectory })), fullHeightRow: 'row2' }));
};
function buildDirectoryTree(rows, parentId) {
    const directories = [];
    for (const row of rows) {
        if (row.parentId === parentId) {
            directories.push({
                row: row,
                children: buildDirectoryTree(rows, row.id),
            });
        }
    }
    return directories;
}
